export class NextivaService {
  public static async SetupChatClient() {
    let nextivaScript = document.createElement("script");
    nextivaScript.setAttribute("type","text/javascript");
    nextivaScript.setAttribute("src","https://portal.unityclient.com/webchat/js/webchat.js");
    nextivaScript.setAttribute("id","WebChatClient");
    nextivaScript.setAttribute("queueId","Dealer.Support.2608573G@nextiva.com");
    nextivaScript.setAttribute("StreamIdentifier","Dealer.Support.2608573G_WebChat_637624803196828395@nextiva.com");
    
    document.head.appendChild(nextivaScript);
  } 
}
